import * as React from 'react';
import * as PropTypes from 'prop-types';
import {ShowInsurancesInfoProps} from '../../../../types/mx/farrera/components';

class ShowInsurancesInfoView extends React.Component<ShowInsurancesInfoProps, {}> {

    static defaultProps = {
        data: {
            coverages: []
        }
    };

    render() {
        const {data: {icon, name, insuranceValueByYear, coverages}} = this.props;
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 p-none pl-0 pr-0">
                                    <div className="header-bar mb-3 d-flex">
                                        <div className="icon mr-3 align-self-center">
                                            <img src={icon} alt={name}/>
                                        </div>
                                        <div className="mr-auto align-self-center">{name}</div>
                                        <div className="ml-auto amount">{insuranceValueByYear}</div>
                                    </div>
                                </div>
                                <ul>
                                    {coverages.map((coverage, index) => <li key={index}>{coverage}</li>)}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ShowInsurancesInfoView;
